import React, { useEffect, useState } from 'react';
import axios from '../helpers/axiosConfig';
import { useParams } from 'react-router-dom';
import getBaseUrl from '../helpers/utility';

const FichePersonnel = () => {
  const { id } = useParams();
  const baseUrl = getBaseUrl();

  const [personnel, setPersonnel] = useState(null);

  useEffect(() => {
    axios
      .get(`personnel/show/${id}`)
      .then((response) => {
        setPersonnel(response.data);
      })
      .catch((error) => {
        console.error('There was an error fetching the personnel data!', error);
      });
  }, [id]);

  if (!personnel) {
    return <div className="container mt-5 pt-5 ">Loading...</div>;
  }

  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('Fr-fr', options);
  };

  const getGrade = () => {
    switch (personnel.arme) {
      case 'AIR':
        return personnel.grade?.gradeair;
      case 'MER':
        return personnel.grade?.grademer;
      default:
        return personnel.grade?.name;
    }
  };

  return (
    <div className="container mt-5 pt-5 ">
      <h2 className="text-center mb-4">Fiche de Renseignement</h2>

      {/* Informations Personnelles */}
      <div className="card mb-3">
        <div className="card-header bg-warning">Informations Personnelles</div>
        <div className="row d-flex justify-content-end ">
          <div className="col">
            <div className="card-body">
              {personnel.compagnie && (
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">
                    <strong>Brigade</strong> : {personnel.compagnie.bataillon.brigade.name || ''}
                  </li>
                  <li class="list-group-item">
                    <strong>Bataillon</strong> : {personnel.compagnie.bataillon.name || ''}
                  </li>
                  <li class="list-group-item">
                    <strong>Compagnie</strong> : {personnel.compagnie.name || ''}
                  </li>
                </ul>
              )}
              <p>
                <strong>Nom et Prénom:</strong> {personnel.nomprenom}
              </p>
              <p>
                <strong>Date de Naissance:</strong>
                {formatDate(personnel.datenaisse)}
              </p>
              <p>
                <strong>Grade:</strong> {getGrade()}
              </p>
              <p>
                <strong>Etsouservice:</strong>
                {personnel.etsouservice && personnel.etsouservice.name}
              </p>
              <p>
                <strong>Compagnie:</strong>
                {personnel.compagnie && personnel.compagnie.name}
              </p>
              <p>
                <strong>Adresse Actuelle:</strong> {personnel.adresseactuelle}
              </p>
              <p>
                <strong>CIN:</strong> {personnel.cin}
              </p>
              <p>
                <strong>Sexe:</strong> {personnel.sexe}
              </p>
              <p>
                <strong>Téléphone:</strong> {personnel.telephone}
              </p>
              <p>
                <strong>WhatsApp:</strong> {personnel.whatsapp}
              </p>
            </div>
          </div>
          <div className="col mb-3 ">
            <p>
              <strong>groupesanguin:</strong> {personnel.groupesanguin}
            </p>
            <p>
              <strong>groupeethnique:</strong> {personnel.groupeethnique}
            </p>
            <p>
              <strong>religion:</strong> {personnel.religion}
            </p>
            <p>
              <strong>affectionactuelle:</strong> {personnel.affectionactuelle}
            </p>
            <p>
              <strong>Matricule:</strong> {personnel.matricule}
            </p>
            <p>
              <strong>Matricule Fincance:</strong> {personnel.MatriculeFinance}
            </p>
            <p>
              <strong>indice:</strong> {personnel.indice}
            </p>
            <p>
              <strong>interruptiondu:</strong> {personnel.interruptiondu}
            </p>
            <p>
              <strong>Au:</strong> {personnel.au}
            </p>
            <p>
              <strong>Sortant Ecole:</strong> {personnel.sortantecole}
            </p>
            
            <p>
              <strong>E-poketra:</strong> {personnel.epoketra}
            </p>
            <p>
              <strong>Numero Carte Verte:</strong> {personnel.numerocarteverte}
            </p>
          </div>
          <div className="col">
            <img src={`${baseUrl}/images/personnels/${personnel.filename}`} width="200" height="auto" alt="" />
          </div>
        </div>
      </div>

      {/* Affectations */}
      <div className="card mb-3">
        <div className="card-header bg-warning  ">
          <div className=" d-flex justify-content-between ">
            <div>AFFECTATIONS SUCCESSIVES</div>
            <div>-</div>
            <div>ENFANTS</div>
            <div></div>
          </div>
        </div>
        <div className=" row card-body">
          <div className="col">
            <table className=" table table-striped table-sm">
              <thead className="thead-dark">
                <tr>
                  <th>Lieu Affect.</th>
                  <th>Fonction tenue</th>
                  <th>Date effet</th>
                  <th>Décision d'affect.</th>
                </tr>
              </thead>
              <tbody>
                {personnel.affectations &&
                  personnel.affectations.map((affectation, index) => (
                    <tr key={index}>
                      <td>{affectation.lieuaffect}</td>
                      <td>{affectation.fonctiontenue}</td>
                      <td>{formatDate(affectation.dateeffet)} </td>
                      <td>{affectation.decisionaffectation}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="col">
            <table className=" table table-striped table-sm">
              <thead className="thead-dark">
                <tr>
                  <th>Nom et prénoms</th>
                  <th>Date Naiss.</th>
                  <th>Sexe</th>
                  <th>Oservation</th>
                </tr>
              </thead>
              <tbody>
                {personnel.enfant &&
                  personnel.enfant.map((enfant, index) => (
                    <tr key={index}>
                      <td> {enfant.nomprenom}</td>
                      <td> {formatDate(enfant.datenaisse)}</td>
                      <td> {enfant.sexe}</td>
                      <td> {enfant.observation}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* Avancements */}
      <div className="card mb-3">
        <div className="card-header bg-warning ">
          <div className=" d-flex justify-content-between ">
            <div>AVANCEMENTS</div>
            <div>-</div>
            <div>DECORATIONS</div>
            <div></div>
          </div>
        </div>
        <div className=" row card-body">
          <div className="col">
            <table className=" table table-striped table-sm">
              <thead className="thead-dark">
                <tr>
                  <th>Statu</th>
                  <th>Référence</th>
                  <th>Dade d'effet</th>
                </tr>
              </thead>
              <tbody>
                {personnel.avancement &&
                  personnel.avancement.map((avancement, index) => (
                    <tr key={index}>
                      <td> {avancement.statu}</td>
                      <td> {avancement.reference}</td>
                      <td>{formatDate(avancement.dateeffet)}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="col">
            <table className=" table table-striped table-sm">
              <thead className=" thead-dark">
                <tr>
                  <th>Décoration</th>
                  <th>Année d'obtention</th>
                  <th>Décret ou Arrêté</th>
                </tr>
              </thead>
              <tbody>
                {personnel.decorations &&
                  personnel.decorations.map((decoration, index) => (
                    <tr key={index}>
                      <td>{decoration.name}</td>
                      <td>{decoration.PersonnelDecoration.dateObtention}</td>
                      <td>{decoration.PersonnelDecoration.decretouarrete}</td>
                      <hr />
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-header bg-warning    ">
          <div className=" d-flex justify-content-between ">
            <div>ECOLE</div>
            <div>-</div>
            <div>Autres compétence</div>
            <div></div>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col">
              <table className=" table table-striped table-sm">
                <thead className="thead-dark">
                  <tr>
                    <th>Intitule</th>
                    <th>Etablissement</th>
                    <th>diplome</th>
                    <th>Année</th>
                  </tr>
                </thead>
                <tbody>
                  {personnel.ecole &&
                    personnel.ecole.map((ecole, index) => (
                      <tr key={index}>
                        <td>{ecole.intitule}</td>
                        <td>{ecole.etablissement}</td>
                        <td>{ecole.diplome}</td>
                        <td>{ecole.annee > 0 ? ecole.annee : ''}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="col">
              <p> N° Permis : {personnel.NumPermis} </p>
              <p> Délivre le : {personnel.permisDelivrele} </p>
              <p> Lieu : {personnel.lieuDelivrance} </p>
              <p> Categorie : {personnel.permisCategorie} </p>
            </div>
          </div>
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-header bg-warning  ">
          <div className=" d-flex justify-content-between ">
            <div>INFORMATIQUE</div>
            <div>-</div>
            <div>LANGUES</div>
            <div></div>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col">
              <p>bureautique : {personnel.bureautique ? 'OUI' : ''}</p>
              <p> {personnel.autres} </p>
            </div>
            <div className="col">
              <label htmlFor="">Langues</label>
              <p>Français : {personnel.francais && personnel.francais} </p>
              <p>Anglais : {personnel.anglais} </p>
              <p>Autres langues : {personnel.autresLangue} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FichePersonnel;
